import { createFileRoute } from '@tanstack/react-router';
import { saveCountryIdBeforeLoad, instagramHashtagAnalyticsStaticData } from '../instagram';

export const Route = createFileRoute('/_private-routes/hashtag-analytics/instagram/$countryId')({
  staticData: instagramHashtagAnalyticsStaticData,
  parseParams: (params) => ({ ...params, countryId: params.countryId.toLowerCase() }),
  beforeLoad: saveCountryIdBeforeLoad({ to: '/hashtag-analytics/instagram' })
});
